module.exports = __webpack_public_path__ + "static/media/notosans-bold.1cd0c57f.woff2";